<div class="layout-wrapper">

  <!-- Sidebar -->
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="logo">
        <img class="logo-icon" src="assets/alyn360.svg">
      </div>
      <div class="date">Wednesday, 26 February 2025</div>
    </div>

    <div class="user-info">
      <div class="user-avatar"></div>
      <span class="user-name"> User</span>
    </div>

    <nav class="sidebar-nav">
      <div class="nav-item active">
        <i class="nav-icon">🏠</i>
        <span class="nav-label">Dashboard</span>
      </div>

      <div class="nav-item">
        <i class="nav-icon">🚚</i>
        <span class="nav-label">Equipment</span>
      </div>

      <div class="nav-item">
        <i class="nav-icon">📦</i>
        <span class="nav-label">Bookings</span>
      </div>

      <div class="nav-item">
        <i class="nav-icon">📊</i>
        <span class="nav-label">Reports</span>
      </div>

      <div class="nav-item">
        <i class="nav-icon">⚙️</i>
        <span class="nav-label">Settings</span>
      </div>
    </nav>
  </div>

  <!-- Main area -->
  <div class="main-area">

    <!-- Topbar -->
    <header class="topbar">
      <div class="left-section">
        <span class="user-name2">Hello Demo User</span>
        <div class="date">Wednesday, 26 February 2025</div>
      </div>

      <div class="right-section">
        <div class="plan-info-navbar">
          <span class="plan-text">Plan: <strong>Free Trial</strong></span>
          <button class="upgrade-btn" disabled>Upgrade</button>
        </div>

        <select>
          <option value="en">English</option>
          <option value="ar">Arabic</option>
        </select>

       <button class="account-btn" (click)="toggleAccountMenu()">
  <mat-icon>account_circle</mat-icon>
</button>

<!-- Dropdown -->
<div class="account-dropdown" *ngIf="showAccountMenu">
  <div class="dropdown-item" (click)="logout()">
    <mat-icon>logout</mat-icon>
    Logout
  </div>
</div>

      </div>
    </header>

    <!-- Content -->
    <div class="content">

      <div class="dashboard-container">

        <!-- Cards -->
        <div class="fleet-cards-container">
          <div class="cards-container">

            <!-- Active Vehicles -->
            <div class="fleet-details-card">
              <div class="card-header">
                <div class="header-content">
                  <h2 class="card-title">Active Vehicles</h2>

                  <div class="main-stats">
                    <div class="total-vehicles">
                      <span class="total-count">12</span>
                    </div>

                    <div class="rented-info">
                      <span class="rented-count">5 Rented</span>
                      <span class="free-count"> • 7 Free</span>
                    </div>

                    <div class="growth-indicator positive">
                      <svg width="16" height="16" viewBox="0 0 24 24">
                        <polyline points="18 15 12 9 6 15" />
                      </svg>
                      <span class="utilization-percentage">64% Utilization</span>
                    </div>
                  </div>
                </div>

                <div class="header-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24">
                    <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                    <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                    <path d="M5 17h-2v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2" />
                    <path d="M9 17v-6h4v6" />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Pending Bookings -->
            <div class="pending-bookings-card">
              <div class="card-header">
                <div class="header-content">
                  <h2 class="card-title">Pending Bookings</h2>

                  <div class="main-stats">
                    <div class="total-bookings">
                      <span class="total-count">3</span>
                    </div>
                    <span class="period-label">Awaiting confirmation</span>

                    <div class="growth-indicator negative">
                      <svg width="16" height="16" viewBox="0 0 24 24">
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                      <span class="growth-percentage">-4% from last week</span>
                    </div>
                  </div>
                </div>

                <div class="header-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </div>
              </div>
            </div>

            <!-- New Enquiries -->
            <div class="new-enquiries-card">
              <div class="card-header">
                <div class="header-content">
                  <h2 class="card-title">New Enquiries</h2>

                  <div class="main-stats">
                    <div class="total-enquiries">
                      <span class="total-count">8</span>
                    </div>

                    <span class="period-label">from last 7 days</span>

                    <div class="growth-indicator positive">
                      <svg width="16" height="16" viewBox="0 0 24 24">
                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                      </svg>
                      <span class="growth-percentage">+10% from last week</span>
                    </div>
                  </div>
                </div>

                <div class="header-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Package Details -->
            <div class="package-details-card">
              <div class="card-header">
                <div class="header-content">
                  <h2 class="card-title">Package Details</h2>

                  <div class="main-stats">
                    <div class="package-info">
                      <span class="plan-name">Free Trial</span>
                      <span class="expiry-date">Valid Till: 25 Feb 2025</span>
                    </div>
                  </div>
                </div>

                <div class="header-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24">
                    <rect x="2" y="4" width="20" height="16" rx="2" ry="2" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="2" y1="10" x2="22" y2="10" />
                  </svg>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Quick Actions -->
        <h2 class="section-title">Quick Actions</h2>
        <div class="quick-actions">
          <div class="quick-card manage">
            <mat-icon>local_shipping</mat-icon>
            <div>
              <h3>Manage Equipment</h3>
              <p>View & manage your equipment</p>
            </div>
          </div>

          <div class="quick-card add">
            <mat-icon>add</mat-icon>
            <div>
              <h3>Add Equipment</h3>
              <p>Add new equipment to your fleet</p>
            </div>
          </div>
        </div>

        <!-- Management -->
        <h2 class="section-title">Management</h2>
        <div class="management-grid">
          <div class="management-card">
            <mat-icon>assignment</mat-icon>
            <h3>Booking Requests</h3>
            <span class="badge">3</span>
          </div>
        </div>

        <!-- Recent Activity -->
        <h2 class="section-title">Recent Activity</h2>
        <div class="activity-list">
          <div class="activity-item">
            <mat-icon>bolt</mat-icon>
            <div>
              <p class="activity-text">New booking request for CAT 320D</p>
              <span class="time">2 hours ago</span>
            </div>
          </div>

          <div class="activity-item">
            <mat-icon>bolt</mat-icon>
            <div>
              <p class="activity-text">Equipment updated: Forklift 3T</p>
              <span class="time">5 hours ago</span>
            </div>
          </div>

          <div class="activity-item">
            <mat-icon>bolt</mat-icon>
            <div>
              <p class="activity-text">Payment received: AED 2,400</p>
              <span class="time">1 day ago</span>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>
